import React, { useState, useEffect } from "react";
import axios from "axios";
import { useOutletContext, useNavigate } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import AddJobRequestModal from "../../components/Modals/AddJobRequestModal";
import EditJobRequestModal from "../../components/Modals/EditJobRequestModal";

function Joblist() {
  const [data, setData] = useState([]);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isAllocateModalOpen, setIsAllocateModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [jobId, setJobId] = useState(null);
  const [roleId, setRoleId] = useState(null);

  const { setGlobalLoading, token } = useOutletContext();
  const navigate = useNavigate();
  const API = process.env.REACT_APP_API_BASE_URL;

  const STATIC_ROLE_ID = 2045;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setGlobalLoading(true);
        const res = await axios.get(`${API}/employeeinfos/joblist/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setData(res.data.lists || []);
      } catch (err) {
        console.error("Fetch failed", err);
        setData([]);
      } finally {
        setGlobalLoading(false);
      }
    };
    fetchData();
  }, [API, token, setGlobalLoading]);

  const handleAddNew = () => {
    console.log("Opening Add Job Modal");
    setSelectedRow(null);
    setIsAddModalOpen(true);
  };

  const openAllocateModal = () => {
    console.log("Allocate User button clicked!");
    setRoleId(STATIC_ROLE_ID);
    setIsAllocateModalOpen(true);
    console.log("State after click:", {
      roleId: STATIC_ROLE_ID,
      isAllocateModalOpen: true,
    });
  };

  const goToShelvedJobs = () => navigate("/employeeinfo/shelved");
  const goToClosedJobs = () => navigate("/employeeinfo/closed");
  const goToRegisteredUsers = () => navigate("/employeeinfo/registeredusers");

  const columns = [
    { accessorKey: "job_id", header: "Job ID" },
    { accessorKey: "department_name", header: "Department" },
    { accessorKey: "designation", header: "Designation" },
    { accessorKey: "role_type", header: "Role Type" },
    { accessorKey: "worklocation", header: "Work Location" },
    { accessorKey: "no_req", header: "Positions Required" },
    { accessorKey: "positions_filled", header: "Positions Filled" },
    { accessorKey: "role_status_name", header: "Role Status" },
    { accessorKey: "createdate", header: "Created" },
    { accessorKey: "TAT", header: "TAT" },
    { accessorKey: "assigned_to", header: "Assigned To" },
    {
      header: "Action",
      id: "action",
      Cell: ({ row }) => (
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() => {
            console.log("Opening Edit Modal for jobId:", row.original.job_id);
            setSelectedRow(row.original);
            setJobId(row.original.job_id);
            setIsEditModalOpen(true);
          }}
        >
          Edit
        </button>
      ),
    },
  ];

  console.log("Render state:", {
    isAllocateModalOpen,
    roleId,
  });

  return (
    <div className="content">
      <div className="card">
        <div className="card-header d-flex align-items-center flex-wrap gap-2">
          <h5 className="mb-0">New Job Requests</h5>
        </div>
        <div className="card-body">
          {data.length === 0 ? (
            <p className="text-muted">No job requests found.</p>
          ) : (
            <MaterialReactTable
              columns={columns}
              data={data}
              enableFilters
              enableColumnOrdering
              initialState={{ pagination: { pageSize: 50 } }}
              muiTableBodyCellProps={{ sx: { padding: "8px 10px" } }}
              muiTableHeadCellProps={{
                sx: { backgroundColor: "#f5f5f5", fontWeight: "bold" },
              }}
              renderTopToolbarCustomActions={() => (
                <div className="d-flex gap-2 align-items-center ms-2 flex-wrap">
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={handleAddNew}
                  >
                    Add Job Request
                  </button>

                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={goToClosedJobs}
                  >
                    Jobs added to pre users
                  </button>
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={goToShelvedJobs}
                  >
                    Shelved Jobs
                  </button>
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={goToRegisteredUsers}
                  >
                    Registered Users
                  </button>
                </div>
              )}
            />
          )}
        </div>
      </div>

      {isAddModalOpen && (
        <AddJobRequestModal
          show={isAddModalOpen}
          onClose={() => setIsAddModalOpen(false)}
          defaultValues={selectedRow}
        />
      )}

      {isEditModalOpen && (
        <EditJobRequestModal
          show={isEditModalOpen}
          onClose={() => setIsEditModalOpen(false)}
          jobId={jobId}
        />
      )}
    </div>
  );
}

export default Joblist;
